import React from 'react'

const Hamilaibolauchahimchuli = () => {
  return (
    <div>
      <div>
        <h3>शब्दभण्डार</h3>
        <h5>१. शब्दकोशको सहायता लिई दिइएका शब्द र अर्थबिच जोडा मिलाउनुहोस् :</h5>
        <p><strong>तिरिन : </strong>घाँस, पराल आदिको थोरै अंश</p>
        <p><strong>डोरेटो : </strong>एक दुई जना मात्र हिँड्न हुने सानो बाटो</p>
        <p><strong>निनी : </strong>गाईका ससाना बाछाबाछीलाई प्यारो गरेर भनिने शब्द</p>
        <p><strong>पातल : </strong>सधैँ हराभरा भइरहने लेकको सेपिलो एवम् घना जङ्गल</p>
        <p><strong>बुकी : </strong>हिमाली भेगमा पाइने भारविशेष</p>
        <p><strong>नागियुँ : </strong>चौरी गाई चर्ने ठाउँ</p>
        <p><strong>छङ्गाछुर : </strong>ज्यादै अग्लो र विकट खालकोभिर वा पहरो खगर : वर्षभरिमा नौ महिना हिउँले ढाकिने ठाउँ</p>
        <p><strong>सामलतुमल : </strong>अन्न आदि खाने कुरा</p>
      </div>
      <hr/>
      <div>
        <h5>२. दिइएका शब्दसँग मिल्ने अनुप्रासयुक्त शब्द पाठबाट खोज्नुहोस् :</h5>
        <p>राम्रा : हाम्रा</p>
        <p>शिखर : रहर</p>
        <p>हेर्लान् : घेर्लान्</p>
        <p>होला : छोला</p>
        <p>हिलाएर : झुलाएर</p>
        <p>ढाक्ला: डाक्ला</p>
        <p>ध्वनि : पनि</p>
        <p>पारी : मारी</p>
        <p>हान्छ : जान्छ</p>
        <p>छाप : नापजाप</p>
      </div>
      <hr/>
      <div>
        <h5>३. दिइएका शब्दको पर्यायवाची शब्द पाठबाट खोज्नुहोस् :</h5>
        <p>चिसो : शीतल</p>
        <p>देउराली : पहाडको उकालो सिद्धिने ठाउँ</p>
        <p>तिरिन : तृण</p>
        <p>टाकुरा : शिखर</p>
        <p>फूल : पुष्प</p>
        <p>बाटो : डोरेटा</p>
      </div>
      <div>
        <hr/>
        <h3>बोध र अभिव्यक्ति</h3>
        <h5>२. उदाहरणमा देखाए जस्तै गरी दिइएका शब्दको अक्षर छुट्याएर शुद्ध उच्चारण गर्नुहोस् :</h5>
        <p>सुसेली : / सु.से.लि /</p>
        <p>हिमचुली : / हिम्.चु.लि /</p>
        <p>शिखर : / सि. खर् /</p>
        <p>उक्लियौला : / उक्.लि.यौं.ला /</p>
        <p>मर्नैपर्छ : / मर्नै पर्छ /</p>
      </div>
      <hr/>
      <div>
        <h5>६. दिइएको कवितांश पढी मौखिक उत्तर दिनुहोस् :</h5>
        <h5>(क) माथिको कवितांशमा कस्तो परिवेशको चित्रण गरिएको छ ?</h5>
        <p>= माथिको कवितांशमा पहाडी भौगोलिक परिवेश चित्रण गरिएको छ। उकाली, देउराली, वनपाखा जस्ता स्थलहरू र बिसौनीमा सुसेरी हाल्दै गीत गाउने, गोठालो जाने, गाई चराउने जस्ता नेपाली ग्रामीण परम्परागत क्रियाकलापहरूले रमणीय पहाडी जीवनशैलीको सुन्दर दृश्य प्रस्तुत गरिएको छ।</p>
        <h5>(ख) ‘देउरालीको बिसौनीमा सुसेलीले गाउँला’ यस कथनको तात्पर्य के हो ?</h5>
        <p>=  ‘देउरालीको बिसौनीमा सुसेलीले गाउँला’ कथनको तात्पर्य देउरालीमा थकाइ मार्दै चिसो बतासको आनन्द लिंदै, सुसेलीको साटो हाल्दै गीत गाउँने र प्रकृतिको रमाइलो अनुभूति गर्ने अवस्था जनाउनु हो।</p>
        <h5>(ग) ‘वनभित्र ढुङ्गामाथि गाउलिन् गोठालिनी’ यस कथनलाई सामान्य पदक्रममा रूपान्तर गर्नुहोस् ।
        </h5>
        <p>= ‘वनभित्र ढुङ्गामाथि गाउलिन् गोठालिनी’ लाई सामान्य पदक्रममा रूपान्तरण गर्दा:
गोठालिनी ढुङ्गामाथि वनभित्र गाउलिन्।</p>
       <h5>(घ) गोठाल्नीले गाईलाई कसरी बोलाउँछिन् ?</h5>
       <p>गोठालिनीले गाईलाई ‘लाला’, ‘ओदी’, ‘निनी’ भनेर बोलाउँछिन्।</p>
      </div>
      <hr/>
      <div>
        <h5>७. ‘टाकुरामा……. नउरङ्गे डाँफे’ कवितांश पढी हिमाली भेगमा पाइने जनावर र बोटबिरुवाका बारेमा छोटो अनुच्छेद लेख्नुहोस् ।</h5>
        <p>= नेपालको हिमाली भेग अत्यन्तै चिसो र कठोर मौसम भएको स्थान हो । यहाँ जनावर र बोटबिरुवाहरूको विविधता सीमित छ, तर ती वातावरणमा अनुकूल भई जीवित रहन सक्षम छन् । हिमाली भेगमा भेडा, चौरी जस्ता बाक्लो रौँ भएका जनावरहरू पाइन्छन्, जसले चिसोबाट आफूलाई बचाउँछन् । त्यस्तै, नौरङ्गी डाँफे जस्ता पन्छीहरू पनि यहाँ देखिन्छन्, जो हिमाली क्षेत्रमा विशिष्ट हुन्छन् । वनस्पतिहरूमा निगाला, बुकी फूल, धुपी जस्ता प्रजातिहरू महत्त्वपूर्ण छन्, जुन यस कठोर वातावरणमा जीवित रहन सक्षम भएका छन् । यी जनावर र बोटबिरुवाहरूले हिमाली भेगको प्राकृतिक सुन्दरता र जैविक विविधता दर्शाउँछन् ।</p>
      </div>
      <hr/>
      <div>
        <h5>८. दिइएको कवितांश पढी सोधिएका प्रश्नको उत्तर लेख्नुहोस् :</h5>
        <h5>(क) माथिको कवितांशमा नेपालीको कस्तो मानसिकताको चित्रण गरिएको छ ?</h5>
        <p>= माथिको कवितांशमा नेपालीहरूको साहसी, शूर र वीर मानसिकताको प्रखर चित्रण गरिएको छ। उनीहरू हिमाल झैँ अटल र अविचलित हुन्छन्, कहिल्यै नझुक्ने स्वाभिमानी स्वभावका हुन्छन्। चाहे जस्तोसुकै कठिनाइ र प्रतिकूल परिस्थिति आए पनि नेपालीहरू सतिसाल झैँ दृढ हृदयका साथ अडिग रहन्छन्। उनीहरू मर्नु जीवनको एक अवश्य भाग हो भनी स्वीकार गर्छन् र मातृभूमिको लागि हाँस्दै आफ्नो प्राणसमेत अर्पण गर्न तयार हुन्छन्। हिमालवासी नेपालीहरू शारीरिक रूपमा बलिया र चट्टानी हुन्छन् जसले कठिन हिमाली यात्रा सजिलै गर्छन्। साथै, उनीहरू जिज्ञासु स्वभावका हुन्छन्, नयाँ कुरा सिक्न र बुझ्न सधैं इच्छुक हुन्छन्। यसरी कवितामा नेपालीहरूको धैर्य, साहस, आत्मविश्वास र अडिग मनोबलको सुन्दर चित्रण गरिएको छ।</p>
        <h5>(ख) नेपालीले हिमचुलीबाट कस्तो प्रेरणा प्राप्त गरेका छन् ?</h5>
        <p>= नेपालीहरू हिमचुलीको काखमा हुर्किएका छन् र हिमचुलीहरू उनीहरूको पहिचान हुन्। सदिऔँदेखि कहिल्यै नझुकी अटल र रहस्यमय हिमचुलीहरूले नेपालीहरूलाई कहिल्यै नझुक्ने, निर्भय र स्वाभिमानी बन्न प्रेरित गरेको छ। हिमचुलीले नदेखेको, नजानेको र नबुझेको कुरामा पनि अघि बढ्न उत्प्रेरणा दिन्छ। विगतमा हाम्रो हिमालले कसैको सामना गर्दा झुक्नुपरेन, त्यसै गरी हामी नेपालीले पनि कहिल्यै अरूसामु झुक्नु हुँदैन। हिमचुलीको उचाइसँगै नेपालीहरूको शान र मान पनि उच्च भएको छ। हामीमा धैर्य, साहस र आत्मबल कहिल्यै डगमगाउन नहुने सन्देश हिमचुलीले दिन्छ। यसैले नेपालीहरूले हिमचुलीबाट सफलताको शिखर चुमेर नयाँ कीर्ति स्थापना गरी राष्ट्र र राष्ट्रियतालाई उजागर गर्ने प्रेरणा पाएका छन्।</p>
      </div>
      <hr/>
      <div>
        <h5>९. ‘हामीलाई बोलाउँछन् हिमचुली’ कवितामा कस्तो परिवेशको चित्रण गरिएको छ, दिइएका बुंदालाई समेत आधार बनाई समीक्षात्मक प्रतिक्रिया लेख्नुहोस् :</h5>
        <p>= ‘हामीलाई बोलाउँछन् हिमचुली’ कवितामा कवि माधवप्रसाद घिमिरेले नेपालको हिमाली भेगको मनमोहक परिवेश र त्यससँग जोडिएको सांस्कृतिक जीवनलाई सुन्दर ढंगले चित्रण गरेका छन्। कवितामा हिमाल, लेक, घना जङ्गल, जडिबुटी, चराचुरुङ्गी, कस्तुरी मृग जस्ता हिमाली प्राकृतिक सम्पदाहरूको माधुर्यात्मक प्रस्तुति गरिएको छ। यसले हिमाली वातावरणको चिसो बतास, कस्तुरीको सुगन्ध र विविध जैविक सम्पत्तिलाई पाठकको मनमा स्पष्ट रूपमा उजागर गर्छ।</p>
        <p>कवि यसले मात्र नभई हिमाली क्षेत्रका मानिसहरूको जीवनशैली र सामाजिक व्यवहारलाई पनि समेटेका छन्। पशुपालन, जडिबुटी सङ्कलन, तथा उनीहरूको साहस र उत्साहको उल्लेखले नेपाली पहाडी समाजको संघर्षशील, कर्मठ र वीर स्वभावको प्रतिनिधित्व गर्दछ। हिमाल आरोहणमा आउने आन्तरिक तथा बाह्य पर्यटकहरूले यस क्षेत्रको सौन्दर्य र प्राकृतिक समृद्धिलाई अझ थप पुष्टि गर्छन्।</p>
        <p>यो कविता नेपाली प्रकृतिप्रेमी, मानवतावादी, तथा राष्ट्रवादी भावनाले भरिपूर्ण छ। कविले लोकछन्द सवाई प्रयोग गरी नेपाललाई हिमचुलीको काखमा अवस्थित प्राकृतिक र सांस्कृतिक आभूषणहरूले सुशोभित देशको रूपमा चित्रण गरेका छन्। कविताले नेपालीहरूको अटल साहस र स्वाभिमान झल्काउँदै हिमाली परिवेशमा समृद्ध जीवन बिताउने मान्छेको चित्र पनि प्रस्तुत गरेको छ।</p>
        <p>यसरी ‘हामीलाई बोलाउँछन् हिमचुली’ कविता प्रकृति र मानवजीवनको अद्भुत संगम हो, जसले नेपाली जनजीवन र हिमाली भेगको सांस्कृतिक पहिचानलाई साहित्यिक रूपमा उजागर गरेको छ।</p>
      </div>
      <hr/>
      <div>
        <h5>१०. ‘हामीलाई बोलाउँछन् हिमचुली’ कविताले दिएको सन्देश के हो, समीक्षात्मक उत्तर लेख्नुहोस् ।</h5>
        <p>= ‘हामीलाई बोलाउँछन् हिमचुली’ कविताले दिएको सन्देश अत्यन्तै प्रेरणादायी, राष्ट्रिय चेतनाले भरिएको र आत्मबल जगाउने खालको छ। राष्ट्रकवि माधवप्रसाद घिमिरेद्वारा रचित यस कविताले नेपालको हिमाली प्रकृतिको सौन्दर्य मात्र चित्रण गर्दैन, त्यसको माध्यमबाट नेपाली जनजीवन, साहस, स्वाभिमान र आत्मविश्वासको उज्यालो सन्देश पनि दिन्छ।</p>
        <p>कवितामा प्रस्तुत गरिएको हिमचुली कुनै सामान्य हिमाल होइन, यो नेपालीहरूको अटलता, स्वाभिमान, नडराउने साहस र अग्लो सोचको प्रतीक बनेर आएको छ। हिमचुलीको उचाइले नेपालीको गौरव, आत्मबल र दृढ इच्छाशक्तिको उचाइलाई जनाउँछ। हिमचुली जसरी कहिल्यै नझुक्ने, अडिग र उज्यालो छ, त्यस्तै नेपाली पनि कहिल्यै नझुक्ने, डर नमान्ने, सामना गर्न तयार हुने स्वभावका हुन्छन् भन्ने सन्देश कविताले दिन्छ।</p>
        <p>कविले कविता मार्फत नेपाली जनतालाई प्रकृतिको जस्तो विशाल, गहिरो र बलियो बन्न प्रेरित गरेका छन्। हिमचुलीको सौन्दर्य, रहस्य र कठोरतालाई आत्मसात गर्दै नेपालीले पनि जस्तोसुकै प्रतिकूलता सामना गर्दै अघि बढ्नुपर्छ भन्ने भावले पाठकमा राष्ट्रिय गौरवको भावना रोपिदिन्छ।</p>
        <p>कविताले ‘हामी सफलताको शिखर चुमेरै छाड्छौं’ भन्ने सकारात्मक र दृढ सन्देश दिएको छ। यसले पाठकमा नकारात्मकता, पराजय वा भयको भावना होइन, आत्मविश्वास, निरन्तर प्रयास, देशप्रेम र स्वाभिमान जगाउने काम गर्छ।</p>
        <p>निष्कर्षमा, यो कविता केवल प्राकृतिक चित्रण होइन, यो नेपालीको साहसी इतिहास, अदम्य आत्मबल र स्वाभिमानको प्रतीक बनिरहेको हिमचुलीबाट प्राप्त प्रेरणालाई उजागर गर्ने गहिरो राष्ट्रिय तथा व्यक्तिगत चेतनाको कविता हो।</p>
      </div>
      <hr/>
      <div>
        <h5>११. दिइएको गजल पढ्नुहोस्, यसको संरचनाका बारेमा हेक्का राख्नुहोस् र आफूलाई मन पर्ने विषयमा एउटा गजलको रचना गर्नुहोस्:</h5>
        <p><strong>आशाको उज्यालो</strong></p>
        <p>नआऊ अन्धकार, मनमा छ आशाको उज्यालो,</p>
        <p>हराउँदैन कहिल्यै, पलमा छ आशाको उज्यालो ।</p>
        <p> </p>
        <p>गरिबका ओठमा हाँसो फुलाउने दिन आउनेछ,</p>
        <p>सपना बन्न सक्ने कर्ममा छ आशाको उज्यालो ।</p>
        <p> </p>
        <p>घामपछाडि लुकेको त्यो जून पनि देखिन्छ,</p>
        <p>अन्धकारसँग लड्न मनमा छ आशाको उज्यालो ।</p>
        <p> </p>
        <p>गुमाउँदैन आत्मबल, आँधीमा पनि उभिन्छ,</p>
        <p>भेटिन्छ उज्यालो जहाँ जहाँ छ आशाको उज्यालो ।</p>
        <p> </p>
        
      </div>
      <hr/>
      <div>
        <h5>१२. दिइएको अनुच्छेद पढ़ी सोधिएका प्रश्नको छोटो उत्तर दिनुहोस् :</h5>
        <h5>(क) कविता भनेको के हो ?</h5>
        <p>= कविता भनेको विचार वा भावनाको लयबद्ध कलात्मक भाषिक अभिव्यक्ति हो ।</p>
        <h5>(ख) कविता र गजलमा के अन्तर छ ?</h5>
        <p>= कविता छन्दमा लेखिएको हुन्छ भने गजल बहरमा लेखिएको हुन्छ । छन्द र बहरको ढाँचा फरक हुने भएकाले यी दुईमा अन्तर छ ।</p>
        <h5>(ग) गजलका संरचक के के हुन् ?</h5>
        <p>= गजलका संरचक बहर, मिसरा, सेर, मत्ला, मक्ता, काफिया, रदिफ हुन् ।</p>
        <h5>(घ) गजलका प्रत्येक सेरको दोस्रो मिसरा कस्तो हुनुपर्छ ?</h5>
        <p>= गजलमा प्रत्येक सेरको दोस्रो मिसरा हमकाफिया अर्थात् अनुप्रासान्त हुनुपर्छ ।</p>
      </div>
      
      <div>
        <hr/>
        <h3>व्याकरण</h3>
        <h5>१. दिइएको अनुच्छेदबाट उपसर्ग व्युत्पन्न शब्द टिप्नुहोस् र तालिकामा देखाए जस्तै गरी उपसर्ग र आधार छुट्याउनुहोस् :</h5>
        <strong>अत्यावश्यक</strong>
        <p>उपसर्ग: अत्य</p>
        <p>आधार शब्द: आवश्यक</p>

        <strong>अधिकार</strong>
        <p>उपसर्ग: अधि</p>
        <p>आधार शब्द: कार</p>

        <strong>अवरोध</strong>
        <p>उपसर्ग: 	अव</p>
        <p>आधार शब्द: रोध</p>

        <strong>समृद्धि</strong>
        <p>उपसर्ग: सम्</p>
        <p>आधार शब्द: ऋद्धि</p>

        <strong>प्रतिकूल</strong>
        <p>उपसर्ग: प्रति</p>
        <p>आधार शब्द: कूल</p>

        <strong>समृद्ध</strong>
        <p>उपसर्ग: सम्</p>
        <p>आधार शब्द: ऋद्ध</p>

        <strong>सुस्वास्थ्य</strong>
        <p>उपसर्ग: सु</p>
        <p>आधार शब्द: स्वास्थ्य</p>

        <strong>समुचित</strong>
        <p>उपसर्ग: सम्</p>
        <p>आधार शब्द: उचित</p>

        <strong>आहार</strong>
        <p>उपसर्ग: 	आ</p>
        <p>आधार शब्द: हार</p>

        <strong>संरक्षण</strong>
        <p>उपसर्ग: सम्</p>
        <p>आधार शब्द: रक्षण</p>

        <strong>संसार</strong>
        <p>उपसर्ग: सम्</p>
        <p>आधार शब्द: सार</p>

        <strong>सङ्कट</strong>
        <p>उपसर्ग: सम्</p>
        <p>आधार शब्द: कट</p>

        <strong>प्रकोप</strong>
        <p>उपसर्ग: प्र</p>
        <p>आधार शब्द: कोप</p>

        <strong>परिणाम</strong>
        <p>उपसर्ग: परि</p>
        <p>आधार शब्द: नाम</p>

        <strong>उत्पन्न</strong>
        <p>उपसर्ग: उत्</p>
        <p>आधार शब्द: पन्न</p>

        <strong>विचार</strong>
        <p>उपसर्ग: 	वि</p>
        <p>आधार शब्द: चार</p>

        <strong>सङगठन</strong>
        <p>उपसर्ग: सङ्</p>
        <p>आधार शब्द: गठन</p>

        <strong>अनुसार</strong>
        <p>उपसर्ग: अनु</p>
        <p>आधार शब्द: सार</p>

        <strong>उपयुक्त</strong>
        <p>उपसर्ग: उप</p>
        <p>आधार शब्द: युक्त</p>

        <strong>अत्यावश्यक</strong>
        <p>उपसर्ग: अति</p>
        <p>आधार शब्द: आवश्यक</p>

        <strong>सचेत</strong>
        <p>उपसर्ग: स</p>
        <p>आधार शब्द: चेत</p>

        <strong>उपचार</strong>
        <p>उपसर्ग: उप</p>
        <p>आधार शब्द: चार</p>

        <strong>विकराल</strong>
        <p>उपसर्ग: वि</p>
        <p>आधार शब्द: कराल</p>

        <strong>विकास</strong>
        <p>उपसर्ग: वि</p>
        <p>आधार शब्द: कास</p>

        <strong>अवरुद्ध</strong>
        <p>उपसर्ग: अव</p>
        <p>आधार शब्द: रुद्</p>

        <strong>प्रयोग</strong>
        <p>उपसर्ग: प्र</p>
        <p>आधार शब्द: योग</p>

        <strong>उपयोग</strong>
        <p>उपसर्ग: उप</p>
        <p>आधार शब्द: योग</p>

        <strong>प्रतिकूल</strong>
        <p>उपसर्ग: प्रति</p>
        <p>आधार शब्द: कूल</p>
      </div>
      <hr/>
      <div>
        <h5>२. भाषातत्वअन्तर्गत १ को अनुच्छेदमा प्रयुक्त ‘सम्’ उपसर्ग लागेर बनेका शब्द ‘सङ्गठन, सञ्चित, सन्तुलित सम्बन्धी संरक्षण को निर्माण प्रक्रिया तलको आरेखमा दिइएको छ । शब्दकोश हेरी ‘सम्’ उपसर्ग लागेर बनेका अन्य दशओटा शब्द टिप्नुहोस् र तिनको निर्माण प्रक्रिया पनि देखाउनुहोस् :</h5>
        <p>सम् + ऋद्ध= समृद्ध</p>
        <p>सम् + सद= संसद</p>
        <p>सम् + मान= सम्मान</p>
        <p>सम् + हार= संहार</p>
        <p>सम् + वाद= संवाद</p>
        <p>सम् + सार= संसार</p>
        <p>सम् + रक्षण= सम्रक्षण</p>
        <p>सम् + वेदना= संवेदना</p>
        <p>सम् + स्मरण= संस्मरण</p>
        <p>सम् + सान= सम्सान</p>
      </div>
      <hr/>
      <div>
        <h5>३. दिइएको तालिकाको बायाँतर्फ उपसर्ग दिइएका छन् र दायाँतर्फ आधार शब्द दिइएका छन् । प्रत्येक आधार शब्दमा एउटा एउटा उपसर्ग संयोजन गरेर नयाँ शब्द बनाउनुहोस् :</h5>
        <p>अनु + गमन= अनुगमन </p>
        <p>अव + नति= अवनति</p>
        <p>निस् + छल= निश्छल</p>
        <p>निर् + ईक्षण= निरीक्षण</p>
        <p>परि + ईक्षा= परीक्षा</p>
        <p>अति + अधिक= अत्यधिक</p>
        <p>सु + आगत= स्वागत</p>
        <p>अधि + आगमन= अध्यागमन</p>
        <p>प्रति + एक= प्रत्येक</p>
        <p>दुस्  + चिन्ता= दुश्चिन्ता</p>
        <p>दुर् + आशय= दुराशय</p>
        <p>वि + ज्ञान= विज्ञान</p>
        <p>सन् + देश= सन्देश</p>
        <p>उत् + नत= उन्नत</p>
        <p>अनु + छेद= अनुच्छेद</p>
      </div>
      <hr/>
      <div>
        <h5>५. दिइएको अनुच्छेदबाट प्रत्यय न्युत्पन्न शब्द टिप्नुहोस् र तालिकामा देखाए जस्तै गरी आधार र प्रत्यय छुट्याउनुहोस् :</h5>
        <p>स्मृ + अनीय= स्मरणीय</p>
        <p>भुल् + अक्कड= भुलक्कड</p>
        <p>परिचय + अक= परिचायक</p>
        <p>संस्कृत + ई= संस्कृति</p>
        <p>कृ + अन= कारण </p>
        <p>जात + ईय= जातीय</p>
        <p>संस्कृति + इक= सांस्कृतिक </p>
        <p>प्राच् + ईन= प्राचीन</p>
        <p>वेद + इक= वैदिक</p>
        <p>नेपाल + ई= नेपाली</p>
        <p>स्वार्थ + ई= स्वार्थी</p>
        <p>भाव + ना= भावना</p>
        <p>पूज् + आ= पूजा</p>
        <p>देव + ता= देवता</p>
        <p>निष्क्रिय + ता= निष्क्रियता</p>
        <p>चोर + ई= चोरी</p>
        <p>ठग् + आहा= ठगाहा</p>
        <p>मिच् + आहा= मिचाहा</p>
        <p>हेप् + आहा= हेपाहा</p>
        <p>चुस् + आहा= चुसाहा</p>
        <p>लुट् + आहा= लुटाहा</p>
        <p>हिंसा + अक= हिंस्रक</p>
        <p>शोष् + अक= शोषक</p>
        <p>शोष् + अण= शोषण</p>
        <p>घमण्ड + ई= घमण्डी</p>
        <p>पिउ + अक्कड= पियक्कड</p>
        <p>बुझ् + अक्कड= बुझक्कड</p>
        <p>भुल् + अक्कड= भुलक्कड</p>
        <p>वन्दना + इय= वन्दनीय</p>
        <p>आदृ + अनीय= आदरणीय</p>
        <p>स्मृ + अनीय= स्मरणीय</p>
        <p>अर्थ + इक= आर्थिक</p>
        <p>सुख + ई= सुखी</p>
        <p>विकृत + इ= विकृति</p>
        <p>अन्त + तः= अन्ततः</p>
        <p>फिर् + अन्ते= फिरन्ते</p>
        <p>माग् + अन्ते= मगन्ते</p>
        <p>जीव + न= जीवन </p>
        <p>उन्नत + इ= उन्नति</p>
        <p>कृ + अक= कारक</p>
      </div>
      <hr/>
      <div>
        <h5>६. तलको तालिकाको बायाँतर्फ धातु र शब्द दिइएका छन् र दायाँतर्फ प्रत्यय दिइएका छन् । प्रत्येक धातु र शब्दबाट एउटा एउटा प्रत्यय संयोजन गरेर कृदन्त व्युत्पन्न र तद्वितान्त व्युत्पन्न शब्द बनाउनुहोस्:</h5>
        <p>दृश् + अक= दर्शक</p>
        <p>सृज् + ति= सृष्टि</p>
        <p>गम् + तब्य= गन्तब्य</p>
        <p>स्मृ + अनीय= स्मरणीय</p>
        <p>श्रु + अन= श्रवण</p>
        <p>नी + त= नीत</p>
        <p>वच् + ता= वक्ता</p>
        <p>नृत् + य= नृत्य</p>
        <p>नी + ता= नेता</p>
        <p>दिन + इक= दैनिक</p>
        <p>स्वर्ण + इम= स्वर्णिम</p>
        <p>ग्राम + ईन= ग्रामीण</p>
        <p>दिवस + ईय= दिवसीय</p>
        <p>राष्ट्र + इय= राष्ट्रिय</p>
        <p>विशेष + तः= विशेषतः</p>
        <p>सुन्दर + य= सौन्दर्य</p>
        <p>महत् + ता= महत्ता</p>
        <p>गुरु + अ= गौर</p>
        <p>वाक् + मय= वाङ्मय</p>
      </div>
      <hr/>
      <div>
        <h5>७. दिइएको अनुच्छेदबाट सन्धियुक्त ब्युत्पन्न शब्द पहिचान गरी तिनको सन्धि विच्छेद गर्नुहोस् :</h5>
        <p>प्रति + एक= प्रत्येक</p>
        <p>सत् + आचार= सदाचार</p>
        <p>सदा + एव= सदैव</p>
        <p>सत् + जन= सज्जन</p>
        <p>सम् + देश= सन्देश</p>
        <p>अनु + सरण= अनुसरण</p>
        <p>निष्क्रिय + ता= निष्क्रियता</p>
        <p>निर् + आशा= निराशा</p>
        <p>निस् + काम= निष्काम</p>
        <p>भाव + ना= भावना</p>
        <p>निर् + अन्तर= निरन्तर</p>
        <p>समर्पण + इत= समर्पित</p>
        <p>सन् + तुलन= सन्तुलन</p>
        <p>अति + अधिक= अत्यधिक</p>
        <p>परीक्षा + इत= परीक्षित</p>
        <p>सम् + कल्प= सङ्कल्प</p>
        <p>प्राप्त + इ= प्राप्ति</p>
        <p>उद् + देश्य= उद्देश्य</p>
        <p>तत् + लीन= तल्लीन</p>
        <p>सफल + ता= सफलता</p>
        <p>स + फल= सफल</p>
        <p>वि + कास= विकास</p>
      </div>
      <hr/>
      <div>
        <h5>८. शुद्ध गरी पुनर्लेखन गर्नुहोस् :</h5>
        <p>म गतहप्ता भृकुटीमण्डपमा विज्ञान प्रदर्शनी हेर्न गएँ । त्यहाँ धेरै किसिमका कम्प्युटर, ल्यापटप र मोबाइलहरू राखिएका थिए । त्यस प्रदर्शनीमा भर्खर कक्षा दश पूरा गरेर एघारमा पढ्दै गरेका विद्यार्थीदेखि एम्. ए. र पि. एच्. डी गरेका प्राध्यापकहरूसमेत आएका थिए । त्यहाँ इज्जतदार, इमानदार, जमिनदार, लेखनदास सबैको जमघट एक ठाउँमा भएको देखेर म दङ्ग परें । मान्छेहरूले खचाखच भरिएको त्यस प्रदर्शनी स्थलबाट एउटा ल्यापटप किनेर सरासर घर फर्के ।</p>
      </div>
    </div>
  )
}

export default Hamilaibolauchahimchuli
